import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { GetOrgazationMembersQuerySchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import type { OrganizationMembers } from "@msuite/utils/types";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

export function useMembers(
	query?: GetOrgazationMembersQuerySchema,
	options?: {
		enabled: boolean;
	},
) {
	/** Hooks */
	const { organization } = useAuth();

	/** Query */
	const { data: members, ..._query } = useQuery({
		queryKey: ["members", guardString(organization?.orgId), JSON.stringify(query || {})],
		queryFn: async () => {
			if (!organization) return [];
			const response = await client.organizations[":orgId"].members.$get({
				param: {
					orgId: guardString(organization.orgId),
				},
				query,
			});
			const data = await responseHandler(response);
			return guardArray(data.members) as OrganizationMembers;
		},
		enabled: options?.enabled ?? true,
	});

	return { members: guardArray(members) as OrganizationMembers, ..._query };
}
